import {
  Pagination as BasePagination,
  PaginationProps as BasePaginationProps,
} from 'antd'

export interface PaginationProps extends BasePaginationProps {}

export const Pagination = (props: PaginationProps): JSX.Element => (
  <>
    <BasePagination {...props} />
  </>
)
